const labels = {
  en: {
    home: "HOME",
    callForPapers: "CALL FOR PAPERS",
    secondCallForPapers: "2<sup>nd</sup> CALL FOR PAPERS",
    thirdCallForPapers: "3<sup>rd</sup> CALL FOR PAPERS",
    workshops: "WORKSHOPS",
    committees: "COMMITTEES",
    information: "PRACTICAL INFORMATION",
    programme: "PROGRAMME",
    registration: "REGISTRATION",
    accommodation: "ACCOMMODATION",
    location: "LOCATION",
    pastConferences: "PAST CONFERENCES",
    news: "NEWS",
    contact: "CONTACT",
    touristGuide: "TOURIST GUIDE",
    travelInfoBelgrade: "TRAVEL INFO - BELGRADE",
    travelInfoFaculty: "TRAVEL INFO - FACULTY",
    bookOfAbstracts: "BOOK OF ABSTRACTS",
    proceedings: "PROCEEDINGS",
    statistics: "STATISTICS",
    participation: "PARTICIPATION",
    organizingCommittee: "ORGANIZING COMMITTEE",
    scientificCommittee: "SCIENTIFIC COMMITTEE",
    reviewers: "REVIEWERS",
    socialProgramme: "GALA DINNER",
    sponsors: "SPONSORS",
    speeches: "KEYNOTE SPEAKERS' SPEECHES",
  },
  sr: {
    home: "početna",
    callForPapers: "pozivno pismo",
    workshops: "radionice",
    committees: "komiteti",
    information: "informacije",
    programme: "program",
    registration: "registracija",
    accommodation: "smeštaj",
    location: "lokacija",
    pastConferences: "prethodne konferencije",
    news: "vesti",
    contact: "kontakt",
    touristGuide: "turistički vodič",
    travelInfo: "putne informacije",
  },
  el: {
    home: "ΑΡΧΙΚΗ",
    callForPapers: "ΠΡΟΣΚΛΗΣΗ ΥΠΟΒΟΛΗΣ ΠΕΡΙΛΗΨΕΩΝ",
    secondCallForPapers: "2<sup>η</sup> ΠΡΟΣΚΛΗΣΗ ΥΠΟΒΟΛΗΣ ΠΕΡΙΛΗΨΕΩΝ",
    thirdCallForPapers: "3<sup>η</sup> ΠΡΟΣΚΛΗΣΗ ΥΠΟΒΟΛΗΣ ΠΕΡΙΛΗΨΕΩΝ",
    workshops: "ΕΡΓΑΣΤΗΡΙΑ",
    committees: "ΕΠΙΤΡΟΠΕΣ",
    information: "ΠΡΑΚΤΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ",
    programme: "ΠΡΟΓΡΑΜΜΑ",
    registration: "ΕΓΓΡΑΦΗ",
    accommodation: "ΔΙΑΜΟΝΗ",
    location: "ΤΟΠΟΘΕΣΙΑ",
    pastConferences: "ΠΡΟΗΓΟΥΜΕΝΑ ΣΥΝΕΔΡΙΑ",
    news: "ΝΕΑ",
    contact: "ΕΠΙΚΟΙΝΩΝΙΑ",
    touristGuide: "ΤΟΥΡΙΣΤΙΚΟΣ ΟΔΗΓΟΣ",
    travelInfoBelgrade: "ΠΛΗΡΟΦΟΡΙΕΣ ΤΑΞΙΔΙΟΥ - ΒΕΛΙΓΡΑΔΙ",
    travelInfoFaculty: "ΠΛΗΡΟΦΟΡΙΕΣ ΤΑΞΙΔΙΟΥ - ΣΧΟΛΗ",
    bookOfAbstracts: "ΒΙΒΛΙΟ ΠΕΡΙΛΗΨΕΩΝ",
    proceedings: "ΠΡΑΚΤΙΚΑ",
    statistics: "ΣΤΑΤΙΣΤΙΚΑ",
    participation: "ΣΥΜΜΕΤΟΧΗ",
    organizingCommittee: "ΟΡΓΑΝΩΤΙΚΗ ΕΠΙΤΡΟΠΗ",
    scientificCommittee: "ΕΠΙΣΤΗΜΟΝΙΚΗ ΕΠΙΤΡΟΠΗ",
    reviewers: "ΑΞΙΟΛΟΓΗΤΕΣ",
    socialProgramme: "ΕΠΙΣΗΜΟ ΔΕΙΠΝΟ",
    sponsors: "ΧΟΡΗΓΟΙ",
    speeches: "ΟΜΙΛΙΕΣ ΠΡΟΣΚΕΚΛΗΜΕΝΩΝ ΟΜΙΛΗΤΩΝ",
  },
}

export default labels
